import { applyTheme } from '../utils/theme'
import { useEffect, useState } from 'react'

export default function ThemeSwitchIcon() {
  const [dark, setDark] = useState(false)
  useEffect(() => {
    setDark(document.documentElement.classList.contains('dark'))
  }, [])
  const toggle = () => {
    const nowDark = document.documentElement.classList.contains('dark')
    applyTheme(nowDark ? 'light' : 'dark')
    setDark(!nowDark)
  }
  return (
    <button className="btn-secondary" onClick={toggle} title={dark ? 'Light' : 'Dark'} aria-label="Toggle theme">
      {dark ? (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M6.76 4.84l-1.8-1.79L3.17 4.84l1.79 1.79 1.8-1.79ZM1 13h3v-2H1v2Zm10 10h2v-3h-2v3Zm9-10v-2h-3v2h3Zm-3.76-8.16 1.79-1.79-1.79-1.79-1.79 1.79 1.79 1.79ZM12 6a6 6 0 1 0 0 12A6 6 0 0 0 12 6Zm0-5h-2v3h2V1Z"/></svg>
      ) : (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a9 9 0 0 0 0 18 9 9 0 0 0 7.74-4.35A8 8 0 0 1 8.35 4.26 9 9 0 0 0 12 2Z"/></svg>
      )}
    </button>
  )
}

